export default __webpack_public_path__ + "static/media/BM_RenderCamera_04_Dining+Interior+Light_Scheme+Living.4f339d3e.jpg";